import { PerfilTalento, PerfilTalentoResumo } from '../models/banco-talentos.model';

export const MEU_PERFIL_MOCK: PerfilTalento = {
  id: 'b0010000-0000-0000-0000-000000000001',
  servidorId: 'd0010000-0000-0000-0000-000000000001',
  matriculaPm: 'PM.2025.000142',
  nomeCompleto: 'João da Silva Oliveira',
  postoGraduacao: 'CAPITAO',
  unidadeNome: 'Batalhão de Operações Especiais (BOPE)',
  idiomas: [
    {
      id: 'i1',
      idioma: 'Inglês',
      nivelCefr: 'C1',
      comprovanteUrl: 'https://storage.sgp.pmdf.df.gov.br/banco-talentos/comprovantes/cert_cambridge.pdf',
    },
    {
      id: 'i2',
      idioma: 'Espanhol',
      nivelCefr: 'B1',
      comprovanteUrl: null,
    },
  ],
  habilidades: [
    {
      id: 'h1',
      nome: 'Piloto de Drone',
      nivel: 'EXPERT',
      descricao: 'Mais de 500 horas de voo e instrutor certificado.',
    },
    {
      id: 'h2',
      nome: 'Primeiros Socorros',
      nivel: 'INTERMEDIARIO',
      descricao: 'Treinamento avançado de APH Tático.',
    },
  ],
  experiencias: [
    {
      id: 'e1',
      cargo: 'Gerente de Projetos de TI',
      empresa: 'Empresa XYZ',
      area: 'Tecnologia da Informação',
      periodoInicio: '2015-02-10',
      periodoFim: '2018-09-30',
      descricao: 'Coordenação de equipes de desenvolvimento e implantação de sistemas corporativos.',
    },
  ],
  certificacoes: [
    {
      id: 'c1',
      nome: 'AWS Certified Solutions Architect',
      orgaoEmissor: 'Amazon Web Services',
      dataEmissao: '2024-05-10',
      numeroCertificado: 'AWS-1294819',
      comprovanteUrl: 'https://storage.sgp.pmdf.df.gov.br/banco-talentos/comprovantes/cert-aws.pdf',
    },
  ],
  interesses: ['TECNOLOGIA', 'INTELIGENCIA'],
  habilitacoesFormais: [
    {
      id: 'f1',
      nomeCurso: 'Curso de Operações Especiais (COEsp)',
      instituicao: 'APM - PMDF',
      dataConclusao: '2023-11-20',
      cargaHoraria: 360,
    },
    {
      id: 'f2',
      nomeCurso: 'Curso de Patrulhamento Tático',
      instituicao: 'APM - PMDF',
      dataConclusao: '2020-06-15',
      cargaHoraria: 120,
    },
  ],
  criadoEm: '2026-05-19T08:00:00-03:00',
  atualizadoEm: '2026-06-11T16:00:00-03:00',
};

export const LISTA_PERFIS_MOCK: PerfilTalentoResumo[] = [
  {
    id: 'b0020000-0000-0000-0000-000000000002',
    servidorId: 'd0020000-0000-0000-0000-000000000002',
    matriculaPm: 'PM.2025.900123-4',
    nomeCompleto: 'Marcos V. Almeida',
    postoGraduacao: 'CAPITAO',
    unidadeNome: 'BOPE',
    habilidadesRelevantes: ['Inglês (C1)', 'Sniper'],
  },
  {
    id: 'b0030000-0000-0000-0000-000000000003',
    servidorId: 'd0030000-0000-0000-0000-000000000003',
    matriculaPm: 'PM.2025.800456-7',
    nomeCompleto: 'Joana D. Costa',
    postoGraduacao: 'TENENTE',
    unidadeNome: 'BOPE',
    habilidadesRelevantes: ['Inglês (B2)', 'TI'],
  },
  {
    id: 'b0040000-0000-0000-0000-000000000004',
    servidorId: 'd0040000-0000-0000-0000-000000000004',
    matriculaPm: 'PM.2025.700189-2',
    nomeCompleto: 'Rafael S. Ramos',
    postoGraduacao: 'SOLDADO',
    unidadeNome: 'BOPE',
    habilidadesRelevantes: ['Primeiros Socorros', 'Língua Brasileira de Sinais (LIBRAS)'],
  },
  {
    id: 'b0050000-0000-0000-0000-000000000005',
    servidorId: 'd0050000-0000-0000-0000-000000000005',
    matriculaPm: 'PM.2025.600210-9',
    nomeCompleto: 'Beatriz F. Lima',
    postoGraduacao: 'CABO',
    unidadeNome: 'BOPE',
    habilidadesRelevantes: ['Piloto de Drone', 'Espanhol (C1)'],
  },
];

export const PERFIL_DETALHE_MOCK_MAP: Record<string, PerfilTalento> = {
  'd0020000-0000-0000-0000-000000000002': {
    id: 'b0020000-0000-0000-0000-000000000002',
    servidorId: 'd0020000-0000-0000-0000-000000000002',
    matriculaPm: 'PM.2025.900123-4',
    nomeCompleto: 'Marcos V. Almeida',
    postoGraduacao: 'CAPITAO',
    unidadeNome: 'Batalhão de Operações Especiais (BOPE)',
    idiomas: [
      {
        id: 'mi1',
        idioma: 'Inglês',
        nivelCefr: 'C1',
        comprovanteUrl: 'https://storage.sgp.pmdf.df.gov.br/banco-talentos/comprovantes/cert_cambridge_marcos.pdf',
      },
    ],
    habilidades: [
      {
        id: 'mh1',
        nome: 'Atirador de Precisão (Sniper)',
        nivel: 'EXPERT',
        descricao: 'Treinamento de precisão e operações táticas especiais.',
      },
      {
        id: 'mh2',
        nome: 'Negociador',
        nivel: 'AVANCADO',
        descricao: 'Certificado em gerenciamento de crises.',
      },
    ],
    experiencias: [
      {
        id: 'me1',
        cargo: 'Instrutor de Tiro Tático',
        empresa: 'Clube de Tiro Civil',
        area: 'Segurança e Treinamento',
        periodoInicio: '2016-01-10',
        periodoFim: '2019-12-31',
        descricao: 'Instrução básica e avançada para uso de armas curtas e longas.',
      },
    ],
    certificacoes: [
      {
        id: 'mc1',
        nome: 'Curso Internacional de Negociação de Crise',
        orgaoEmissor: 'FBI Academy',
        dataEmissao: '2022-04-18',
        numeroCertificado: 'FBI-849182',
        comprovanteUrl: 'https://storage.sgp.pmdf.df.gov.br/banco-talentos/comprovantes/fbi-cert.pdf',
      },
    ],
    interesses: ['OPERACIONAL', 'INTELIGENCIA'],
    habilitacoesFormais: [
      {
        id: 'mf1',
        nomeCurso: 'Curso de Operações Especiais (COEsp)',
        instituicao: 'APM - PMDF',
        dataConclusao: '2023-11-20',
        cargaHoraria: 360,
      },
    ],
    criadoEm: '2026-05-19T08:00:00-03:00',
    atualizadoEm: '2026-06-11T16:00:00-03:00',
  },
  'd0030000-0000-0000-0000-000000000003': {
    id: 'b0030000-0000-0000-0000-000000000003',
    servidorId: 'd0030000-0000-0000-0000-000000000003',
    matriculaPm: 'PM.2025.800456-7',
    nomeCompleto: 'Joana D. Costa',
    postoGraduacao: 'TENENTE',
    unidadeNome: 'Batalhão de Operações Especiais (BOPE)',
    idiomas: [
      {
        id: 'ji1',
        idioma: 'Inglês',
        nivelCefr: 'B2',
        comprovanteUrl: null,
      },
      {
        id: 'ji2',
        idioma: 'Alemão',
        nivelCefr: 'A2',
        comprovanteUrl: null,
      },
    ],
    habilidades: [
      {
        id: 'jh1',
        nome: 'Desenvolvimento de Software (TI)',
        nivel: 'AVANCADO',
        descricao: 'Conhecimentos sólidos em Java, Spring Boot e SQL.',
      },
    ],
    experiencias: [
      {
        id: 'je1',
        cargo: 'Analista de Sistemas',
        empresa: 'SoftTech Ltda.',
        area: 'Tecnologia da Informação',
        periodoInicio: '2018-03-01',
        periodoFim: '2021-08-30',
        descricao: 'Desenvolvimento e manutenção de software web corporativo.',
      },
    ],
    certificacoes: [],
    interesses: ['TECNOLOGIA', 'PLANEJAMENTO'],
    habilitacoesFormais: [],
    criadoEm: '2026-05-20T09:00:00-03:00',
    atualizadoEm: '2026-06-11T10:00:00-03:00',
  },
};
